export const LOADCITIES_START = 'react/cities/LOADCITIES_START';
export const LOADCITIES_COMPLETE = 'react/cities/LOADCITIES_COMPLETE';
export const LOADCITIES_ERROR = 'react/cities/LOADCITIES_ERROR';
export const CHANGECITIES = 'react/cities/CHANGECITIES';
export const ADDCITIES = 'react/cities/ADDCITIES';
export const CITIES_DESTROY = 'react/cities/CITIES_DESTROY';

const initialState = {
  list: [],
  value: '',
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADCITIES_COMPLETE:
      return {
        ...state,
        list: action.result.cities || [],
        loading: false
      };
    case LOADCITIES_START:
      return {
        ...state,
        loading: true
      };
    case LOADCITIES_ERROR:
      return {
        ...state,
        list: [],
        loading: false
      };
    case CHANGECITIES:
      return {
        ...state,
        value: action.data
      };
    case ADDCITIES:
      try {
        return {
          ...state,
          list: action.data
        };
      } catch (err) {
        return {
          ...state,
          list: [],
        };
      }
    case CITIES_DESTROY:
      return initialState;
    default:
      return state;
  }
}

export function loadCities(data) {
  return {
    types: [LOADCITIES_START, LOADCITIES_COMPLETE, LOADCITIES_ERROR],
    promise: (client) => client.get('/api/address/areas/' + data)
  };
}

export function changeCities(data) {
  return {
    type: CHANGECITIES,
    data
  };
}

export function addCities(data) {
  return {
    type: ADDCITIES,
    data
  };
}

export function destroyCities() {
  return { type: CITIES_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/cities.js